import { smButtonClassName } from "@/components/AdminPanel/Organization/components/manage-pane-primitives";
import { Button } from "@/components/ui/button";
import { cn } from "@/utils";
import type { MouseEvent, ReactNode } from "react";

/** Settings › Model providers' Connect, compacted for a card or a menu row. */
export function ConnectAgentButton({
  onClick,
  className,
  children = "Connect",
}: {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <Button
      variant="secondary"
      size="sm"
      className={cn(
        "shrink-0 cursor-pointer",
        smButtonClassName,
        "h-6 min-h-6 px-2.5 text-xs",
        className,
      )}
      onClick={(event) => {
        event.stopPropagation();
        onClick(event);
      }}
    >
      {children}
    </Button>
  );
}
